var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsLittleMoreSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_319_1517)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 18,
    stroke: "#EEEB4E",
    strokeWidth: 3.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 41C34.2843 41 41 34.2843 41 26C41 17.7157 34.2843 11 26 11C17.7157 11 11 17.7157 11 26C11 34.2843 17.7157 41 26 41Z",
    fill: "#EEEB4E",
    stroke: "#EEEB4E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 33H29.6666",
    stroke: "#6E6C0E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8999 18.1382C19.6135 16.9889 20.6709 16.7056 22.7295 16.8441",
    stroke: "#6E6C0E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0997 18.1382C32.3862 16.9889 31.3287 16.7056 29.2701 16.8441",
    stroke: "#6E6C0E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 27.375C21.7557 27.375 22.875 26.2557 22.875 24.875C22.875 23.4943 21.7557 22.375 20.375 22.375C18.9943 22.375 17.875 23.4943 17.875 24.875C17.875 26.2557 18.9943 27.375 20.375 27.375Z",
    fill: "#6E6C0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 27.375C33.0057 27.375 34.125 26.2557 34.125 24.875C34.125 23.4943 33.0057 22.375 31.625 22.375C30.2443 22.375 29.125 23.4943 29.125 24.875C29.125 26.2557 30.2443 27.375 31.625 27.375Z",
    fill: "#6E6C0E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_319_1517",
    x: 0.0000243187,
    y: 0.00039053,
    width: 52,
    height: 51.9992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2,
    result: "effect1_foregroundBlur_319_1517"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsLittleMoreSelected);
export default __webpack_public_path__ + "static/media/hurts-little-more-selected.1b7846cbef0b46079ea8e1b1970d7cfc.svg";
export { ForwardRef as ReactComponent };